
	import {Options, Vue} from "vue-property-decorator";
	import VideoView from "@/components/telehealth/VideoView.vue";

	@Options({components: {VideoView}})
	export default class VideoViewForIonSlides extends Vue
	{
	}
